export default __webpack_public_path__ + "static/media/chair-1-seat-1-back.9a852540.webp";